// extracted by mini-css-extract-plugin
module.exports = {"shadowBox":"shadowBox_shadowBox__ZKpZy","animateOnHoverMobile":"shadowBox_animateOnHoverMobile__Tx_D4","animateOnHoverDesktop":"shadowBox_animateOnHoverDesktop__dR7j_"};